import { Radio, RadioGroup } from 'components/RadioGroup'
import { Key } from 'react'
import { ReviewAssetType, ReviewType } from '../types'
import { ReviewTypeIcon } from 'components/ReviewTypeIcon/ReviewTypeIcon'
import { Button } from '../../Button'
import { useReviewsWizard } from '../ReviewsWizardProvider'
import { EventId, StateId } from '../machineTypes'
import { useSelector } from '@xstate/react'
import Styles from './TypeSelection.module.scss'
import { ReviewTemplates } from '../ReviewTemplates/ReviewTemplates'
import { Modal } from 'almanac-ui/Modal'
import { RadioOption } from './RadioOption'

export const TypeSelection = () => {
  const { service } = useReviewsWizard()
  const reviewType = useSelector(service, (state) => state.context.reviewType)
  const reviewAnything = useSelector(service, (state) => state.context.assetType === ReviewAssetType.ExternalLink)
  const isFetchingReviewConfig = useSelector(service, (state) =>
    state.matches(StateId.TYPE_SELECTION_FETCHING_REVIEW_TYPE_CONFIG),
  )

  const handleBack = () => {
    if (reviewAnything) service.send(EventId.BACK)
  }

  return (
    <>
      <Modal.Header title="What kind of review would you like to start?" />
      <Modal.Content>
        <div className={Styles.presetsTitle}>Presets</div>
        <RadioGroup
          value={reviewType || ReviewType.FEEDBACK}
          onChange={(key: Key) => service.send(EventId.SELECT_TYPE, { reviewType: key })}
          className={Styles.radioGroup}
          aria-label="What kind of review would you like to start?"
        >
          <Radio value={ReviewType.FEEDBACK} hideRadio className={Styles.radio}>
            {(props) => (
              <RadioOption
                {...props}
                icon={<ReviewTypeIcon reviewType={ReviewType.FEEDBACK} />}
                title="Collect Feedback"
                description="Ends on due date; comments and changes are not binding"
              />
            )}
          </Radio>
          <Radio value={ReviewType.APPROVAL} hideRadio className={Styles.radio}>
            {(props) => (
              <RadioOption
                {...props}
                icon={<ReviewTypeIcon reviewType={ReviewType.APPROVAL} />}
                title="Request Formal Approval"
                description="Approver must sign off to close the review"
              />
            )}
          </Radio>
          <Radio value={ReviewType.READ_RECEIPTS} hideRadio className={Styles.radio}>
            {(props) => (
              <RadioOption
                {...props}
                icon={<ReviewTypeIcon reviewType={ReviewType.READ_RECEIPTS} />}
                title="Read Receipts"
                description="Ask anyone to mark the doc as read"
              />
            )}
          </Radio>
        </RadioGroup>
        <ReviewTemplates />
      </Modal.Content>
      <Modal.Footer>
        <Modal.FooterContent slot="left">
          {reviewAnything && (
            <Button variant="tertiary" size="xl" onPress={handleBack}>
              Back
            </Button>
          )}
        </Modal.FooterContent>
        <Modal.FooterContent slot="right">
          <Button
            isDisabled={!reviewType || isFetchingReviewConfig}
            onPress={() => service.send(EventId.CONTINUE)}
            size="xl"
          >
            Configure Your Review
          </Button>
        </Modal.FooterContent>
      </Modal.Footer>
    </>
  )
}
